module.exports = __webpack_public_path__ + "img/123.5ed69f32.svg";